var $162a1ecb6581c36a$exports = {};
$162a1ecb6581c36a$exports = {
    "time": `Time`,
    "startTime": `Start time`,
    "endTime": `End time`
};


export {$162a1ecb6581c36a$exports as default};
//# sourceMappingURL=en-US.mjs.map
